import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// Register service worker for push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker?.register('/sw.js')?.then((registration) => {
        console.log('Service Worker registered:', registration);
      })?.catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
